import React from 'react'

import LKGrid from 'shared/LKGrid'
import LKModal from 'shared/LKModal'

import translate from '../../../translator'
import DLConfig from './DLConfig'

import container from './container'
import { withConstantPermissions } from '../../../../shared'

@container
@withConstantPermissions()
class Officer extends React.Component {
  getContextMenu = ({
    node: {
      data: { ManagerID },
    },
  }) =>
    this.props.base.IsArrested !== 1
      ? [
          {
            name: translate('cmd_del_curr_assistant'),
            icon: 'delete',
            action: () => this.props.openConfirmation(ManagerID),
            disabled: this.props.loading,
            permissionKey: 'LOAN_DEL_OFFICER',
          },
        ]
      : []

  render() {
    const { instanceName, data, loading } = this.props

    return (
      <>
        <LKModal.Confirmation
          name="DeleteLoanOfficerConfirmation"
          onConfirm={this.props.deleteOfficer}
          loading={loading}
        />
        <LKGrid
          instanceName={instanceName}
          rowData={data} // removed as even if user has permission or not it should list officer in Loan {this.props.permissions.VIEW_LOAN_OFFICER ? data : []}
          getContextMenuItems={this.getContextMenu}
          onRowSelected={this.handleRowSelection}
          {...DLConfig}
        />
      </>
    )
  }
}

export default Officer
